/**
 * State migration — brings old saved states up to the current schema.
 * Called by loadProject before returning the state to the app.
 * Always safe to call on a current state (no-op if already up to date).
 */
import { mkEmpty } from "./dcel";

export function migrateState(raw) {
  if (!raw || typeof raw !== "object") return mkEmpty();

  const fresh = mkEmpty();
  const st    = { ...raw };

  // v2 → v3: add layers, symbols, annotations, manualDims, gridLines, drawing
  if (!st.layers)      st.layers      = fresh.layers;
  if (!st.symbols)     st.symbols     = {};
  if (!st.annotations) st.annotations = {};
  if (!st.manualDims)  st.manualDims  = {};
  if (!st.gridLines)   st.gridLines   = {};
  if (!st.drawing)     st.drawing     = fresh.drawing;
  if (!st.drawing.sectionCuts) st.drawing = { ...st.drawing, sectionCuts: [] };

  // Ensure all system layers exist (user may have old partial layer set)
  for (const [id, layer] of Object.entries(fresh.layers)) {
    if (!st.layers[id]) st.layers[id] = layer;
  }

  // Ensure rooms exists
  if (!st.rooms)       st.rooms       = {};
  if (!st.openings)    st.openings    = {};
  if (!st.opLog)       st.opLog       = [];
  if (!st._healLog)    st._healLog    = [];
  if (!st.layerStates) st.layerStates = {};
  if (!st.constraints) st.constraints = {};
  if (!st.drawingMode) st.drawingMode = "architectural";
  if (!st.circles)     st.circles     = {};
  if (!st.arcs)        st.arcs        = {};
  if (!st.splines)     st.splines     = {};
  if (!st.polylines)   st.polylines   = {};
  if (!st.faceHatches)     st.faceHatches     = {};
  if (!st.circleHatches)   st.circleHatches   = {};
  if (!st.polylineHatches) st.polylineHatches = {};
  if (!st.blockDefs)   st.blockDefs   = {};
  if (!st.blockRefs)   st.blockRefs   = {};
  if (st.floorIndex === undefined) st.floorIndex = 0;
  if (!st.floors)      st.floors      = { 0: null };

  st.version = 3;
  return st;
}
